import { render, staticRenderFns } from "./menutabs.vue?vue&type=template&id=9fbe4f4c&scoped=true&"
import script from "./menutabs.vue?vue&type=script&lang=js&"
export * from "./menutabs.vue?vue&type=script&lang=js&"
import style0 from "./menutabs.vue?vue&type=style&index=0&id=9fbe4f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbe4f4c",
  null
  
)

export default component.exports